module.exports = __webpack_public_path__ + "static/media/GE.2e945191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GE.svg
// module id = 258
// module chunks = 0